import { render } from "./RevenueStream.vue?vue&type=template&id=0552bc00"
import script from "./RevenueStream.vue?vue&type=script&lang=js"
export * from "./RevenueStream.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__